import { jsx as t } from "react/jsx-runtime";
const x = ({
  fill: r = "none",
  height: o = 24,
  stroke: s = "none",
  width: n = 24,
  ...e
}) => /* @__PURE__ */ t(
  "svg",
  {
    fill: r,
    height: o,
    stroke: s,
    viewBox: `0 0 ${n} ${o}`,
    width: n,
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  }
);
export {
  x as Icon
};
